import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { CandidatesUploadSelect } from './store';

@Injectable()
export class CandidateUploadSelectResolver {
  constructor(private store: Store<{}>) {}

  resolve(route: ActivatedRouteSnapshot): Observable<void> | void {
    this.store.dispatch(new CandidatesUploadSelect(route.params.id));
  }
}
